var render, staticRenderFns
import script from "./MpTileRecipeCard.vue?vue&type=script&lang=js&"
export * from "./MpTileRecipeCard.vue?vue&type=script&lang=js&"
import style0 from "./MpTileRecipeCard.vue?vue&type=style&index=0&id=75aa457a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa457a",
  null
  
)

export default component.exports